import { render, staticRenderFns } from "./DetailDisplay.vue?vue&type=template&id=256b6ad0"
import script from "./DetailDisplay.vue?vue&type=script&lang=js"
export * from "./DetailDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports